class Accordion {
  constructor(element) {
    this.element = element;
    this.init();
  }

  getElement() {
    return this.element;
  }

  getAccordion() {
    let element = this.getElement();
    return element.querySelectorAll("[data-accordion-title]");
  }

  setAccordion() {
    let accordionEl = this.getAccordion();

    for (let accordion of accordionEl) {
      accordion.addEventListener("click", (event) => {
        event.preventDefault();
        if (accordion.getAttribute('aria-expanded') === 'true') {
          accordion.nextElementSibling.style.height = 0;
          accordion.setAttribute('aria-expanded', false);
        } else {
          try {
            accordion.closest("ul").querySelector("[aria-expanded='true']").nextElementSibling.style.height = 0;
            accordion.closest("ul").querySelector("[aria-expanded='true']").setAttribute('aria-expanded', false);
          } catch {}
          accordion.nextElementSibling.style.height = accordion.nextElementSibling.scrollHeight + "px";
          accordion.setAttribute('aria-expanded', true);
        }
      });
    }
  }

  removeEventHandlers() {
    let accordionEl = Array.from(this.getAccordion());

    accordionEl.map((accordion) => {
      accordion.removeEventListener('click');
    })
  }

  setEventHandlers() {
    this.setAccordion();
  }

  init() {
    this.setEventHandlers();
  }
}

const AccordionInit = {
  init() {
    const $el = document.querySelectorAll("[data-accordion]");
    if ($el.length) {
      for (let $e of $el) {
        new Accordion($e);
      }
    }
  },
};


export default AccordionInit;